<div class="viewcontainer">
  <div class="head">
      <app-header [Message]="Header" [path]="path" [Action]="ButtonAction" [ConfirmHead]='confirmHeading'
          [Visible]='visible' [Confirmbody]='confirmBody' (exposeChild)="showDataFromChild($event)" ></app-header>
  </div>
  <div class="topbar">
      <ul class="row top">
          <li class="col-sm-2 col-md-2 col-lg-2 passive" (click)="step(1)"
              [ngClass]="{'active': activeFlag> 0, 'highlighted': activeFlag === 1, 'cursorClick': (route.snapshot.url[0].path == 'projectedit' || route.snapshot.url[0].path == 'importxml' || activeFlag > 1)}">
              Customer Info </li>
              <li class="col-sm-2 col-md-2 col-lg-2 passive" (click)="step(2)"
              [ngClass]="{'active': activeFlag> 1, 'highlighted': activeFlag === 2, 'cursorClick': (route.snapshot.url[0].path == 'projectedit' || route.snapshot.url[0].path == 'importxml' || activeFlag > 2)}">
              Site Info </li>
              <!-- Modified by JW(2022-08-16): select calculation type -->
          <li *ngIf="calculationType==='CLD'" class="col-sm-2 col-md-2 col-lg-2 passive" (click)="step(3)"
              [ngClass]="{'active': activeFlag> 2, 'highlighted': activeFlag === 3, 'cursorClick': (route.snapshot.url[0].path == 'projectedit' || route.snapshot.url[0].path == 'importxml' || activeFlag > 3)}">
              Contamination </li>
              <!-- Modified by JW(2022-08-16): select calculation type -->
          <li *ngIf="calculationType==='ASTM'" class="col-sm-2 col-md-2 col-lg-2 passive" (click)="step(3)"
              [ngClass]="{'active': activeFlag> 2, 'highlighted': activeFlag === 3, 'cursorClick': (route.snapshot.url[0].path == 'projectedit' || route.snapshot.url[0].path == 'importxml' || activeFlag > 3)}">
              ASTM Settings </li>
          <li *ngIf="calculationType==='CLD'" class="col-sm-1 col-md-1 col-lg-1 passive" (click)="step(4)"
              [ngClass]="{'active': activeFlag> 3, 'highlighted': activeFlag === 4, 'cursorClick': (route.snapshot.url[0].path == 'projectedit' || route.snapshot.url[0].path == 'importxml' || activeFlag > 4)}">
              Solutions </li>
              <!-- Modified by JW(2022-08-16): select calculation type -->
              <!-- Modified by JW(2022-08-26): astm result-start -->
          <li *ngIf="calculationType==='ASTM'" class="col-sm-2 col-md-2 col-lg-2 passive" (click)="step(4)"
              [ngClass]="{'active': activeFlag> 3, 'highlighted': activeFlag === 4, 'cursorClick': (route.snapshot.url[0].path == 'projectedit' || route.snapshot.url[0].path == 'importxml' || activeFlag > 4)}">
              Results </li>
          <li *ngIf="calculationType==='ASTM'" class="col-sm-2 col-md-2 col-lg-2 passive" (click)="step(5)"
              [ngClass]="{'active': activeFlag> 4, 'highlighted': activeFlag === 5, 'cursorClick': (route.snapshot.url[0].path == 'projectedit' || route.snapshot.url[0].path == 'importxml' || activeFlag > 5)}">
              Report Generation </li>
              <!-- Modified by JW(2022-08-26): astm result-end -->
          <li *ngIf="calculationType==='CLD'" class="col-sm-1 col-md-1 col-lg-1 passive" (click)="step(5)"
              [ngClass]="{'active': activeFlag> 4, 'highlighted': activeFlag === 5, 'cursorClick': (route.snapshot.url[0].path == 'projectedit' || route.snapshot.url[0].path == 'importxml' || activeFlag > 5)}">
              Results </li>
          <li *ngIf="calculationType==='CLD'" class="col-sm-2 col-md-2 col-lg-2 passive" (click)="step(6)"
              [ngClass]="{'active': activeFlag> 5, 'highlighted': activeFlag === 6, 'cursorClick': (route.snapshot.url[0].path == 'projectedit' ||  route.snapshot.url[0].path == 'importxml' || activeFlag > 6)}">
              Report Generation </li>
          <li class="col-sm-2 col-md-2 col-lg-2 navigationstep passive">
              <div class="cursor prev" [ngClass]="activeFlag > 1? 'enabled': 'disabled'" (click)="prevStep()">
                  <fa-icon class="icon" [icon]="faAngleLeft"></fa-icon><span class="label">Previous</span>
              </div>
              <span class="sepration"> | </span>
              <div class="cursor" [ngClass]="activeFlag < 6? 'enabled': 'disabled'" (click)="nextStep()"><span
                      class="label">Next</span>
                  <fa-icon class="icon" [icon]="faAngleRight"></fa-icon>
              </div>
          </li>
      </ul>
  </div>
  <div class="flex-containter" (click)="onMouseClick($event)">
    <div class="full-width" *ngIf="activeFlag == 1">
       <app-customer-info (nextStep)='nextStep()'></app-customer-info>
    </div>
    <div class="full-width" *ngIf="activeFlag == 2">
     <app-site-info (nextStep)='nextStep()'></app-site-info>
    </div>
    <!-- Modified by JW(2022-08-16): select calculation type -->
    <div class="full-width" *ngIf="activeFlag == 3 && calculationType==='CLD'">
      <app-contamination (nextStep)='nextStep()' ></app-contamination>
    </div>
    <div class="full-width" *ngIf="activeFlag == 3 && calculationType==='ASTM'">
      <app-astm (nextStep)='nextStep()' ></app-astm>
    </div>
     <!-- Modified by JW(2022-08-16): select calculation type -->
    <div class="full-width" *ngIf="activeFlag == 4 && calculationType==='CLD'">
      <app-solution (nextStep)='nextStep()' ></app-solution>
    </div>
    <!-- Modified by JW(2022-08-26): astm result-start -->
    <div class="full-width" *ngIf="activeFlag === 4 && calculationType === 'ASTM'">
      <app-astm-result (nextStep)='nextStep()'></app-astm-result>
    </div>
    <div class="full-width" *ngIf="activeFlag === 5 && calculationType === 'ASTM'">
      <app-astm-report (nextStep)='nextStep()'></app-astm-report>
    </div>
    <!-- Modified by JW(2022-08-26): astm result-end -->
    <div class="full-width" *ngIf="activeFlag == 5 && calculationType==='CLD'">
      <app-result (nextStep)='nextStep()' ></app-result>
    </div>
    <div class="full-width" *ngIf="activeFlag == 6">
      <app-reports (nextStep)='nextStep()'></app-reports>
    </div>

  </div>
</div>

<!-- Save & Load Calculation - START -->
<div class="modal fade" id="saveas" tabindex="-1" role="dialog" aria-labelledby="saveas" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Save As</h5>
                <span class="menubar Exportenabled point" data-toggle="modal" data-target="#newFolder"><span class="foldericon">
                        <fa-icon [icon]="faFolderPlus"></fa-icon>
                    </span> <span>New Folder</span></span>
            </div>
            <div class="modal-body">
                <div class="breadcrmb">
                    <div (click)="goTofolder(item, i)" [ngClass]="i != folderPath.length-1 ? 'point': '' "
                        *ngFor="let item of folderPath;  let i = index">
                        <span class="foldericon">
                            <fa-icon [icon]="faFolderOpen"></fa-icon>
                        </span><span> {{item.Title}} <span *ngIf="i != folderPath.length - 1">/</span> </span>
                    </div>
                </div>
                <div *ngIf="!CreateNewFolder" class="flexbox">
                    <div class="card ProjectCard" *ngFor="let item of availableFolders; let i = index">
                        <div (dblclick)="openChild(item, false)" *ngIf="item.Type == 'Folder'" class="folderCard">
                            <div class="folderImg">
                                <fa-icon [icon]="faFolderOpen"></fa-icon>
                            </div>
                            <div class="folderDetails">
                                <div class="card-title"> {{item.Fname}} </div>
                                <div class="card-desc">
                                    <span>Created by: {{item.Name}} on {{item.newDate}}</span>
                                </div>
                                <div class="totalProj">
                                    <span>{{item.TotalFile}} Project(s)</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-grp">
                <div class="cancel point" data-dismiss="modal" aria-label="Close" (click)="addRemoveZIndex('add')">Cancel</div>
                <div class="next-button-content" data-dismiss="modal" aria-label="Close">
                    <button class="button-content ripple" (click)='CheckProjectExist()'>
                        <span class='space'>Save</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade newF" id="newFolder" tabindex="-1" role="dialog" aria-labelledby="newFolder" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">New Folder</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    <div class="linkContent">
                        <input type="text" class="fullwidth p10" [(ngModel)]="newFolderName" >
                    </div>
                </div>
            </div>
            <div class="next-button-content flexend">
                <button class="button-content ripple btnNo" data-dismiss="modal" aria-label="Close">
                    Cancel
                </button>
                <button class="button-content ripple" data-dismiss="modal" aria-label="Close" (click)='createFolder(newFolderName)'>
                   Create
                </button>
            </div>
        </div>
    </div>
</div>

<div class="d-flex justify-content-center cover-spin" *ngIf="saving">
    <div class="spinner-border" role="status">
       <span class="sr-only">Saving...</span>
    </div>
</div>

<ng-template #projectOverwriteConfirm let-modal class="overwriteConfirm">
    <div class="modal-contents">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Overwrite Project</h5>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(true)">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div>
                <div class="linkContent">
                    <span class="linkText">Project Already Exist. Overwrite?</span>
                </div>
            </div>
        </div>
        <div class="next-button-content flexend">
            <button class="button-content ripple btnNo" (click)="modal.dismiss(true)" aria-label="Close">
                No
            </button>
            <button class="button-content ripple" (click)="ProceedSaveToDb()" data-dismiss="modal" aria-label="Close">
                Yes
            </button>
        </div>
    </div>
</ng-template>
<!-- Save & Load Calculation - END -->

<ng-template #projectConfirmSaveChanges let-modal class="confirmSaveChanges">
  <div class="modal-contents">
      <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Confirmation</h5>
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(true)">
              <span aria-hidden="true">&times;</span>
          </button>
      </div>
      <div class="modal-body">
          <div>
              <div class="linkContent">
                  <span class="linkText">{{strSaveConfirmMsg}}</span>
              </div>
          </div>
      </div>
      <div class="next-button-content flexend">
          <button class="button-content ripple btnNo" (click)="modal.dismiss(true)" aria-label="Close">
              No
          </button>
          <button class="button-content ripple" (click)="ProceedSaveToDb()" data-dismiss="modal" aria-label="Close">
              Yes
          </button>
      </div>
  </div>
</ng-template>



